// extracted by mini-css-extract-plugin
export default {"productSection":"ProductSection_productSection__4O-Y7","productDescription":"ProductSection_productDescription__5EQZN"};